import imageCompression from 'browser-image-compression';
import { supabase } from '../lib/supabaseClient';

export async function compressImage(file: File, maxSizeMB = 1) {
  const options = { maxSizeMB, useWebWorker: true };
  return await imageCompression(file, options);
}

export async function uploadFile(bucket: string, file: File, path?: string) {
  const filename = path || `${Date.now()}_${file.name}`;
  const { error } = await supabase.storage.from(bucket).upload(filename, file, { upsert: false });
  if (error) throw error;
  const { data: urlData } = supabase.storage.from(bucket).getPublicUrl(filename);
  return urlData.publicUrl;
}

export async function createSignedUrl(bucket: string, path: string, expiresIn = 60): Promise<string> {
  const { data, error } = await supabase.storage.from(bucket).createSignedUrl(path, expiresIn);
  if (error) throw error;
  return data.signedUrl;
}
